import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { PARTNERS } from "@/lib/gallery";

export const Partners = () => (
  <section id="partenaires" data-testid="partners-section" className="border-t border-paper-line bg-paper px-5 py-20 sm:px-8">
    <div className="mx-auto grid max-w-[1400px] gap-10 lg:grid-cols-12 lg:items-center">
      <div className="lg:col-span-4">
        <p className="eyebrow text-gold-deep mb-5">Nos partenaires</p>
        <h2 className="font-display text-3xl sm:text-4xl leading-[1.05]">Des artisans de confiance, <em className="text-clay">à nos côtés.</em></h2>
      </div>
      <div className="lg:col-span-8 grid gap-4 sm:grid-cols-2">
        {PARTNERS.map((p) => (
          <Reveal key={p.name}>
            <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`partner-link-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex items-center justify-between gap-6 border border-paper-line bg-white p-7 transition-colors duration-500 hover:bg-ink hover:text-paper">
              <span>
                <span className="block font-display text-4xl tracking-[0.04em]">{p.name}</span>
                <span className="mt-2 block text-sm text-slate-600 transition-colors duration-500 group-hover:text-paper/80">{p.activity} · {p.city}</span>
                <span className="mt-3 block font-mono text-xs text-gold-deep group-hover:text-gold">{p.url.replace("https://", "")}</span>
              </span>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-ink/20 transition-[transform,border-color,background-color] duration-500 group-hover:rotate-45 group-hover:border-gold group-hover:bg-gold group-hover:text-ink">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
